import { FC, HTMLAttributes, PropsWithChildren } from 'react'

/** Props for the shared card container. */
type CardProps = PropsWithChildren<HTMLAttributes<HTMLDivElement>>

/** Simple card wrapper used for repeated box styling. */
export const Card: FC<CardProps> = ({ children, className, ...props }) => {
  const classes = [
    'rounded-xl bg-brand-smoky/80 p-4 shadow-[0_12px_30px_rgba(0,0,0,0.35)] ring-1 ring-black/20',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return <div className={classes} {...props}>{children}</div>
}
